import IndexTable from '@lib/components/index-table/IndexTable';
import SPFPOCartIndexTableRow from './SPFPOCartIndexTableRow';

export default class SPFPOCartIndexTable extends IndexTable {
    static defaultProps = {
        features: []
    }

    rowComponentClass = SPFPOCartIndexTableRow;

    renderTableFoot() {
        let colSpan = 2;
        let label = 'Total PPL';
        const totalNetPriceColumn = this.props.page.props.columns.find(x => x.slug === 'TotalNetPrice');
        if (totalNetPriceColumn && totalNetPriceColumn.visible) {
            colSpan = 4;
            label = 'Total net price';
        }

        return (
            <tfoot>
            <tr>
                <td colSpan={colSpan}></td>
                <td>{__(label)}</td>
                <td>{this.props.page.props.priceSummary.totalNetPrice}</td>
            </tr>
            </tfoot>
        )
    }
}
